import { track } from "jiffy-analytics";
import { on as onEvent } from "common/utils/ui/event";
import "./jiffymade-landing-faq.scss";

const SHOWN_CLASS = "jiffymade-landing-faq__faq-item--shown";

document.addEventListener("DOMContentLoaded", () => {
  onEvent("click", ".js-jiffymade-landing-faq-link", (_, $target) => {
    const $parent = $target.parentElement;
    $parent.classList.toggle(SHOWN_CLASS);

    track("faq_question_clicked", {
      interaction_type: $parent.classList.contains(SHOWN_CLASS) ? "expand" : "collapse",
      question: $target.textContent.trim()
    });
  });
});

const jiffymadeLandingFaq = {
  init: () => {
    // Initialization logic is already handled by DOMContentLoaded event
  }
};

export default jiffymadeLandingFaq;
export { jiffymadeLandingFaq };
